import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import {
  CatalogNameExtension,
  catalogTeamNameValidation,
  GenericValueInputPicker,
  GenericValuePickerExtension,
  RepoNamePicker,
  GithubTeamPickerExtension,
  AzSecurityGroupPickerExtension,
  AzureSubscriptionPickerExtension,
  AzureLogin,
  AzureLoginSchema,
  GithubLogin,
  GithubLoginSchema,
  KaapTenantPicker,
  KaapTenantPickerSchema,
  KaapNameInput,
  KaapTenantNameSchema,
  KaapAzureToken,
  KaapApplicationSelector,
  KaapCabInform,
  KaapClusterNodeGroupPicker,
  KaapGitOpsConfig,
  AzureSecurityGroupMultiValue,
  KaaPAzureSecurityGroupMultiValue,
  KubernetesClusterPicker,
  KubernetesClusterPickerSchema,
  DaasComponentPicker,
  daasComponentPickerValidation,
  DaasProjectInput,
  daasProjectInputValidation,
  DaasApplicationInput,
  daasApplicationInputValidation,
  DaasApplicationSetInput,
  daasApplicationSetInputValidation,
  TypographyLabel,
  UserGroupsPicker,
  SuporgPicker,
} from './components';
import { CatalogUserPicker } from './components/CatalogUserPicker';
import { MyCostCentersPicker } from './components/MyCostCentersPicker';
import { RepoNamePickerSchema } from './components/RepoNamePicker/schema';
import { repoNamePickerValidation } from './components/RepoNamePicker/validation';
import { TextInput } from './components/TextInput';
import { textInputValidation } from './components/TextInput/validation';
import { UrlInput, validateUrlInput } from './components/UrlInput';

export const GenericValueInputPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GenericValueInputPicker',
    component: GenericValueInputPicker,
  }),
);

export const GenericValuePickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GenericValuePicker',
    component: GenericValuePickerExtension,
  }),
);

export const CatalogNamePickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CatalogNamePicker',
    component: CatalogNameExtension,
    validation: catalogTeamNameValidation,
  }),
);

export const RepoNamePickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RepoNamePicker',
    component: RepoNamePicker,
    validation: repoNamePickerValidation,
    schema: RepoNamePickerSchema,
  }),
);

export const GithubTeamPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubTeamPicker',
    component: GithubTeamPickerExtension,
  }),
);

export const AzSecurityGroupPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AzSecurityGroupPicker',
    component: AzSecurityGroupPickerExtension,
  }),
);

export const AzureSubscriptionPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AzureSubscriptionPicker',
    component: AzureSubscriptionPickerExtension,
  }),
);

export const CatalogUserPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CatalogUserPicker',
    component: CatalogUserPicker,
  }),
);

export const AzureLoginFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AzureLogin',
    component: AzureLogin,
    schema: AzureLoginSchema,
  }),
);

export const GithubLoginFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubLogin',
    component: GithubLogin,
    schema: GithubLoginSchema,
  }),
);

export const UrlInputExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'UrlInput',
    component: UrlInput,
    validation: validateUrlInput,
  }),
);

export const MyCostCentersPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'MyCostCentersPicker',
    component: MyCostCentersPicker,
  }),
);

export const KaapTenantPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'KaapTenantPicker',
    component: KaapTenantPicker,
    schema: KaapTenantPickerSchema,
  }),
);

export const KaapTenantNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'KaapTenantName',
    component: KaapNameInput,
    schema: KaapTenantNameSchema,
  }),
);

export const KaapAzureTokenFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'KaapAzureToken',
    component: KaapAzureToken,
  }),
);

export const KaapApplicationSelectorFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'KaapApplicationSelector',
    component: KaapApplicationSelector,
  }),
);

export const KaapCabInformFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'KaapCabInform',
    component: KaapCabInform,
  }),
);

export const KaapClusterNodeGroupPickerFieldExtension =
  scaffolderPlugin.provide(
    createScaffolderFieldExtension({
      name: 'KaapClusterNodeGroupPicker',
      component: KaapClusterNodeGroupPicker,
    }),
  );

export const KaapGitOpsConfigFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'KaapGitOpsConfig',
    component: KaapGitOpsConfig,
  }),
);

export const AzureSecurityGroupMultiValueExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AzureSecurityGroupMultiValue',
    component: AzureSecurityGroupMultiValue,
  }),
);

export const KaaPAzureSecurityGroupMultiValueExtension =
  scaffolderPlugin.provide(
    createScaffolderFieldExtension({
      name: 'KaaPAzureSecurityGroupMultiValue',
      component: KaaPAzureSecurityGroupMultiValue,
    }),
  );

export const KubernetesClusterPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'KubernetesClusterPicker',
    component: KubernetesClusterPicker,
    schema: KubernetesClusterPickerSchema,
  }),
);

export const TextInputFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'TextInput',
    component: TextInput,
    validation: textInputValidation,
  }),
);

export const DaasComponentPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DaasComponentPicker',
    component: DaasComponentPicker,
    validation: daasComponentPickerValidation,
  }),
);

export const DaasProjectInputFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DaasProjectInput',
    component: DaasProjectInput,
    validation: daasProjectInputValidation as any,
  }),
);

export const DaasApplicationInputFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DaasApplicationInput',
    component: DaasApplicationInput,
    validation: daasApplicationInputValidation as any,
  }),
);

export const DaasApplicationSetInputFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DaasApplicationSetInput',
    component: DaasApplicationSetInput,
    validation: daasApplicationSetInputValidation as any,
  }),
);

export const TypographyLabelFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'TypographyLabel',
    component: TypographyLabel,
  }),
);

export const UserGroupsPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'UserGroupsPicker',
    component: UserGroupsPicker,
  }),
);

export const SuporgPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SuporgPicker',
    component: SuporgPicker,
  }),
);
